<style src="./style.scss">

</style>

<div class="sections-form">
    <div class="mbsc-form-group">
        <div class="mbsc-form-group-title">En esta sesión...</div>
        <ul class="mbsc-cloak section-list-view">
            {#each sections as section}
            <li>
                {section.name}
                <ul>
                    {#each section.sub as subSection}
                    <li class="section-item" data-icon="play" data-time="{subSection.time}">
                        {subSection.name}
                    </li>
                    {/each}
                </ul>
            </li>
            {/each}
        </ul>
    </div>
</div>
<script>
    import { onMount, afterUpdate } from 'svelte';

    import { createEventDispatcher } from 'svelte';

    const DEBUG = document.location.protocol === 'http:' ? true : false;
    const dispatch = createEventDispatcher();

    export let sections = null;

    let sectionsList = null;
    import dnsLogo from './../../../public/images/d-ns-panel.jpg';

    afterUpdate(() => {});

    onMount(async () =>{
        mobiscroll.form('.sections-form', {
            theme: 'd-ns'
        });
        mobiscroll.listview('.section-list-view', {
            swipe: false,
            enhance: true,
            striped: true,
            onItemTap: function(event, instance) {
                if (event.target.dataset.time) {
                    const items = document.querySelectorAll('.section-item');
                    items.forEach((item) => {
                        item.classList.remove('time-selected');
                    });
                    event.target.classList.add('time-selected');
                    dispatch('sectionSelected', {
                        section: event.target.dataset.time,
                    });
                }
            },
        });
    });
</script>
